import { WeakType } from '../typescript-migration';
import { ClientFactory } from './create-http-client';

import { Client } from './http';

const SCREEN_WIDTH =
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth;

export const PAGE_SIZE = SCREEN_WIDTH >= 1025 && SCREEN_WIDTH <= 1919 ? 24 : 30;
export default class Library {
  public httpClient: Client;

  constructor(
    config: WeakType,
    httpClient: Client = ClientFactory.HttpClient(config),
  ) {
    Object.assign(this, config, {
      httpClient,
      doEnableScaling:
        typeof config.doEnableScaling === 'boolean'
          ? config.doEnableScaling.toString()
          : config.doEnableScaling,
      activePulse: config.featureFlags?.['active-pulse'],
    });
  }
}
